import { useParams, useSearchParams } from "react-router-dom";
import { useIntl } from "@leagueplatform/locales";
import { usePageViewAnalytics } from "@leagueplatform/analytics";
import { useDocumentTitle } from "@leagueplatform/web-common";
import { Masonry } from "@leagueplatform/masonry";
import { MASONRY } from "common/constants";
import { PageContentWrapper } from "components/page-content-wrapper.component";
import { PageHeader } from "components/page-header/page-header.component";

export const ResourceDetailPage = () => {
  const { resourceId } = useParams<{ resourceId: string }>();
  const [searchParams] = useSearchParams();
  const title = searchParams.get("title") ?? "";

  usePageViewAnalytics({ screen_name: "Resource Detail" });
  const { formatMessage } = useIntl();
  useDocumentTitle(formatMessage({ id: "STR_RESOURCE_DETAIL" }));

  return (
    <PageContentWrapper>
      <PageHeader variant="sub-page" mobileBand="green" headingText={title} />
      <Masonry
        rootNodeId={MASONRY.ROOT_NODE_ID_RESOURCE_DETAIL}
        initialQueryParams={{ resourceId: resourceId ?? "" }}
      />
    </PageContentWrapper>
  );
};
